import 'driver.js/dist/driver.css';
import './assets/design-fto-onboarding.scss';
import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { DesignFtoOnboardingService } from './design-fto-onboarding-service';
import { DesignFtoOnboardingRuntime } from './design-fto-onboarding-runtime';
import { DesignFtoOnboardingServiceImpl } from './impls/design-fto-onboarding-service';
import { DesignFtoOnboardingRuntimeImpl } from './impls/design-fto-onboarding-runtime';
import { DesignFtoReportOnboardingService } from './design-fto-report-onboarding-service';
import { DesignFtoReportOnboardingServiceImpl } from './impls/design-fto-report-onboarding-service';

/** 注册 Design FTO 上传、示例与提交操作引导。 */
export const designFtoOnboardingModule = (bind: interfaces.Bind) => {
    bind(DesignFtoOnboardingRuntime).to(DesignFtoOnboardingRuntimeImpl);
    bind(DesignFtoOnboardingService).to(DesignFtoOnboardingServiceImpl).inTransientScope();
    bind(DesignFtoReportOnboardingService).to(DesignFtoReportOnboardingServiceImpl).inSingletonScope();
};

export { DesignFtoOnboardingService } from './design-fto-onboarding-service';
export type { DesignFtoOnboardingStartOptions } from './design-fto-onboarding-service';
export { DesignFtoOnboardingRuntime } from './design-fto-onboarding-runtime';
export { DesignFtoOnboardingServiceImpl } from './impls/design-fto-onboarding-service';
export { DesignFtoOnboardingRuntimeImpl } from './impls/design-fto-onboarding-runtime';
export { DesignFtoReportOnboardingService } from './design-fto-report-onboarding-service';
export type {
    DesignFtoReportOnboardingService as DesignFtoReportOnboardingServiceType,
} from './design-fto-report-onboarding-service';
export { DesignFtoReportOnboardingServiceImpl } from './impls/design-fto-report-onboarding-service';
export {
    registerDesignFtoReportOnboardingDebug,
} from './design-fto-report-onboarding-debug';
export type {
    DesignFtoReportOnboardingDebugApi,
} from './design-fto-report-onboarding-debug';
